import React, { useRef, useState } from "react";
import { Row, Col, Button, Modal } from "antd";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import ReactPlayer from "react-player";
import PaginationComponent from "../Pagination/PaginationComponent";
import { CloseOutlined } from "@ant-design/icons";
import { scroll } from "../../components/utils/utils";

interface MediaItem {
  id: number;
  name: string;
  attachment_ids?: string;
  video_url?: string;
}

interface PreviewMediaProps {
  mediaItems: MediaItem[];
  loading: boolean;
  itemPerPage: number;
  isVideo: boolean;
  title?: string;
  twoPerRow?: boolean;
}

const PreviewMedia = ({
  mediaItems,
  itemPerPage,
  isVideo,
  title,
  twoPerRow = false,
}: PreviewMediaProps) => {
  const currentRef = useRef<HTMLDivElement>(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState<number | null>(null);

  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };

  const handleItemClick = (index: number) => {
    setCurrentIndex(index);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setCurrentIndex(null);
  };

  // Sorting the data by sequence
  const sortedData = mediaItems
    .map((report: any) => report)
    .sort((a: any, b: any) => a.sequence - b.sequence);

  const startIndex = (currentPage - 1) * itemPerPage;
  const currentMediaItems = sortedData.slice(
    startIndex,
    startIndex + itemPerPage
  );

  const handleArrowClick = (direction: "left" | "right") => {
    if (currentIndex !== null) {
      let newIndex = currentIndex;

      if (direction === "left") {
        newIndex = currentIndex > 0 ? currentIndex - 1 : mediaItems.length - 1;
      } else if (direction === "right") {
        newIndex = currentIndex < mediaItems.length - 1 ? currentIndex + 1 : 0;
      }

      setCurrentIndex(newIndex);
    }
  };

  return (
    <div
      className={`takaful--video-album-container${
        twoPerRow ? " takaful--media-two-per-row" : ""
      }`}
      ref={currentRef}
    >
      {title && <h2 className="takaful--video-album-title">{title}</h2>}
      <Row
        key={currentPage}
        gutter={[{ xxl: 16, xl: 16, lg: 16, md: 16, sm: 0, xs: 0 }, 48]}
        justify="center"
        className="takaful--video-album-container"
      >
        {currentMediaItems.map((item, index) => (
          <Col
            key={index}
            {...(twoPerRow
              ? { xxl: 12, xl: 12, lg: 12, md: 12, sm: 24, xs: 24 }
              : { xxl: 7, xl: 7, lg: 11, md: 11, sm: 24, xs: 24 })}
          >
            <div
              onClick={() => handleItemClick(startIndex + index)}
              className="takaful--video-photo-container"
            >
              {isVideo ? (
                <ReactPlayer
                  url={item.video_url}
                  light
                  width="100%"
                  height="100%"
                  style={{ aspectRatio: "16/9" }}
                />
              ) : (
                <img
                  src={item.attachment_ids}
                  alt={`مرفق ${index + 1}`}
                  className="takaful--video-photo-container"
                />
              )}
              {item.name && (
                <div className="takaful--video-overlay">{item.name}</div>
              )}
            </div>
          </Col>
        ))}
      </Row>

      <div className="takaful--pagination-container">
        {mediaItems && mediaItems.length > itemPerPage && (
          <PaginationComponent
            active={currentPage}
            total={mediaItems.length}
            itemPerPage={itemPerPage}
            scroll={() => scroll(currentRef)}
            setActive={(nb) => updateActive(nb)}
          />
        )}
      </div>

      {isModalOpen && (
        <Modal
          open={isModalOpen}
          footer={null}
          onCancel={handleCloseModal}
          width={800}
          centered
          maskClosable={false}
          closable={false}
          title={""}
          className="takaful--custom-video-modal"
        >
          <Row>
            <Col span={3} />
            <Col span={18}>
              <div className="takaful--modal-title-container">
                <span
                  onClick={handleCloseModal}
                  className="takaful--close-icon"
                >
                  <CloseOutlined />
                </span>
                <span className="takaful--modal-title">
                  {currentIndex !== null ? mediaItems[currentIndex].name : ""}
                </span>
              </div>
            </Col>
            <Col span={3} />
          </Row>
          <Row>
            <Col span={3}>
              <Button
                icon={<IoIosArrowBack />}
                onClick={() => handleArrowClick("left")}
                className="takaful--modal-arrow-button takaful--modal-arrow-left"
              />
            </Col>
            <Col span={18}>
              <div className="takaful--video-modal-col">
                {currentIndex !== null &&
                  (isVideo ? (
                    <ReactPlayer
                      url={mediaItems[currentIndex].video_url}
                      playing
                      controls
                      width="100%"
                    />
                  ) : (
                    <img
                      src={mediaItems[currentIndex].attachment_ids}
                      alt={`مرفق ${currentIndex + 1}`}
                      className="takaful--modal-image"
                    />
                  ))}
              </div>
            </Col>
            <Col span={3}>
              {" "}
              <Button
                icon={<IoIosArrowForward />}
                onClick={() => handleArrowClick("right")}
                className="takaful--modal-arrow-button takaful--modal-arrow-right"
              />
            </Col>
          </Row>
          <div className="modal-arrow-container"></div>
        </Modal>
      )}
    </div>
  );
};

export default PreviewMedia;
